import bookCalendar from "./calendar/calendar";
import stepOne from "./checkout/steps/step-one/step-one";
import bookingSteps from "./steps";
import asideSummary from "./checkout/steps/aside-summary";
import bookingStripeProcess from "./checkout/stripe-process";
import CheckTime from "./checkout/check-time";

// Remove Stored Data
const modChecktime = new CheckTime();
modChecktime.startCountDown();

// Calendar
const book_calendar = bookCalendar();

// Step one
const modStepOne = new stepOne(book_calendar);
modStepOne.init();

// Aside summary
const modAsideSummary = new asideSummary();
modAsideSummary.store(book_calendar);

// Steps
const bookingStepsInstance = new bookingSteps(
    "#site-form-booking", 
    ".step-booking",
    "#prevBookingButton",
    "#nextBookingButton",
    '#btn-payment',
    '#booking-payment-element',
);

const modBookingStripeProcess = new bookingStripeProcess(
    '#site-form-booking',
    '#booking-form-process',
    '#booking-payment-element',
    '#booking-loading-payment',
    '#booking-payment-response',
    '#booking-pay-reinit',
    '#btn-payment',
    '#booking-payment-spinner',
    '#booking-payment-button-text',
);

(async () => {
    try {
        await modBookingStripeProcess.init();
        await modBookingStripeProcess.showForm();
    } catch (error) {
        console.error("Errore nell'inizializzazione del pagamento:", error);
    }
})();